<template>
	<main-tabs :links="links">
		<router-view></router-view>
	</main-tabs>
</template>

<script>
	export default {
		data() {
			return {
				links: [{
					to: {
						path: '/settings/token/facebook'
					},
					label: 'Facebook'
				}]
			}
		}
	}
</script>

